// @ts-nocheck
import { handleSavePdfButtonClick } from "../handlers/buttons/pdf";
import {
    handleAssignConnectionPoints,
    handleCalculateNetwork,
    handleCallNetworkInfoWindow,
    handleFocusFlowRateInput,
    handleCreateTheSame,
    handleDelete,
    handleDisplayAll,
    handleEscape,
    handleHide,
    handleHideBlockSearch,
    handleJoin,
    handleKeyboard,
    handleMakeBlock,
    handleMakeOffset,
    handleMakeOffsetGuide,
    handleRemoveGuides,
    handleSaveShapesToDatabase,
    handleSaveToBlockCollection,
    handleSelect,
    handleSelectAll,
    handleShowBlockSearch,
    handleStampClick
} from "../services/operations";
import { generateDXFContent } from "../shared/export/dxf";
import { Command } from "./Command";
import { ObjectTypes } from "../shared/enums";

export interface CommandTypes {
    line: string;
    symline: string;
    rectangle: string;
    circle: string;
    square: string;
    free: string;
    move: string;
    rotate: string;
    rotateCopy: string;
    copy: string;
    mirror: string;
    scale: string;
    break: string;
    text: string;
    select: string;
    delete: string;
    offset: string;
    offsetGuide: string;
    removeGuides: string;
    none: string;
    join: string;
    createTheSame: string;
    hide: string;
    displayAll: string;
    selectAll: string;
    moveRoutePart: string;
    edit: string;
    dxf: string;
    pdf: string;
    save: string;
    stamp: string;
    networkHeating: string;
    callNetworkInfoWindow: string;
    focusFlowRateInput: string;
    escape: string;
    shift: string;
    keyboard: string;
    makeBlock: string;
    assignConnectionPoints: string;
    showBlockSearch: string;
    hideBlockSearch: string;
    saveToBlockCollection: string;
}

export interface CommandMap {
    [key: string]: Command;
    line: Command;
    symline: Command;
    rectangle: Command;
    circle: Command;
    square: Command;
    move: Command;
    rotate: Command;
    rotateCopy: Command;
    copy: Command;
    mirror: Command;
    scale: Command;
    break: Command;
    text: Command;
    select: Command;
    selectAll: Command;
    delete: Command;
    offset: Command;
    offsetGuide: Command;
    removeGuides: Command;
    join: Command;
    createTheSame: Command;
    hide: Command;
    displayAll: Command;
    moveRoutePart: Command;
    dxf: Command;
    pdf: Command;
    save: Command;
    stamp: Command;
    networkHeating: Command;
    callNetworkInfoWindow: Command;
    focusFlowRateInput: Command;
    escape: Command;
    keyboard: Command;
    makeBlock: Command;
    assignConnectionPoints: Command;
    showBlockSearch: Command;
    hideBlockSearch: Command;
    saveToBlockCollection: Command;
}

export class CommandListClass {
    /**
     * Коллекция всех команд
     */
    public types: CommandTypes;
    public cm: CommandMap;

    constructor() {
        this.types = {
            line: ObjectTypes.line,
            symline: 'symline',
            rectangle: ObjectTypes.rectangle,
            circle: ObjectTypes.circle,
            square: 'square',
            free: ObjectTypes.block,
            move: 'move',
            rotate: 'rotate',
            rotateCopy: 'rotate-copy',
            copy: 'copy',
            mirror: 'mirror',
            scale: 'scale',
            break: 'break',
            text: 'text',
            select: 'select',
            delete: 'delete',
            offset: 'offset',
            offsetGuide: 'offset-guide',
            removeGuides: 'remove-guides',
            none: 'none',
            join: 'join',
            createTheSame: 'create-the-same',
            hide: 'hide',
            displayAll: 'displayAll',
            selectAll: 'selectAll',
            moveRoutePart: 'move-route-part',
            edit: 'edit',
            dxf: 'dxf',
            pdf: 'pdf',
            save: 'save',
            stamp: 'stamp',
            networkHeating: 'networkHeating',
            callNetworkInfoWindow: 'call-network-info-window',
            focusFlowRateInput: 'focus-flow-rate-input',
            escape: 'escape',
            shift: 'angle-snap',
            keyboard: 'keyboard',
            makeBlock: 'make-block',
            assignConnectionPoints: 'assign-connection-points',
            showBlockSearch: 'show-block-search',
            hideBlockSearch: 'hide-block-search',
            saveToBlockCollection: 'save-to-block-collection',
        };

        this.cm = {
            line: new Command(this.types.line, 'Линия', 'Создание линии по двум точкам', 'l', 'д', null, null),
            symline: new Command(this.types.symline, 'Симметричная линия', 'Создание симметричной линии', 'alt+l', 'alt+д', null, null),
            rectangle: new Command(this.types.rectangle, 'Прямоугольник', 'Создание прямоугольника по двум точкам', 'k', 'л', null, null),
            circle: new Command(this.types.circle, 'Круг', 'Создание окружности по двум точкам', 'e', 'у', null, null),
            square: new Command(this.types.square, 'Квадрат', 'Создание квадрата по двум точкам', 'q', 'й', null, null),
            move: new Command(this.types.move, 'Перемещение', 'Перемещение фигур', 'm', 'ь', null, null),
            rotate: new Command(this.types.rotate, 'Поворот', 'Поворот фигур', 'r', 'к', null, null),
            rotateCopy: new Command(this.types.rotateCopy, 'Поворот с копированием', 'Поворот фигуры с копированием', 'alt+r', 'alt+к', null, null),
            copy: new Command(this.types.copy, 'Копирование', 'Копирование фигур', 'c', 'с', null, null),
            mirror: new Command(this.types.mirror, 'Зеркальное отображение', 'Зеркальное отображение фигур', 'i', 'ш', null, null),
            scale: new Command(this.types.scale, 'Масштаб', 'Масштабирование фигур', 'w', 'ц', null, null),
            break: new Command(this.types.break, 'Разрыв линии', 'Разрыв линии или прямоугольника', 'b', 'и', null, null),
            text: new Command(this.types.text, 'Текст', 'Набор текста', 't', 'е', null, null),

            select: new Command(this.types.select, 'Выбор', 'Выбор элементов', 's', 'ы', handleSelect, null),
            selectAll: new Command(this.types.selectAll, 'Выбор всех фигур', 'Выбор всех элементов, какие есть на чертеже', 'ctrl+a', 'ctrl+ф', handleSelectAll, null),
            delete: new Command(this.types.delete, 'Удаление', 'Удаление фигур', 'del', 'del', handleDelete, null),
            offset: new Command(this.types.offset, 'Маршрут с отступом', 'Создание маршрута с отступом', 'n', 'т', handleMakeOffset, null),
            offsetGuide: new Command(this.types.offsetGuide, 'Создание направляющих', 'Создание направляющих из линий или прямоугольников', 'g', 'п', handleMakeOffsetGuide, null),
            removeGuides: new Command(this.types.removeGuides, 'Удалить направляющий', 'Удаление всех направляющих', 'a', 'ф', handleRemoveGuides, null),
            // none: new Command(this.types.none, 'Отсутствие команды', 'Никакие команды не выполняются', null, null, null),
            join: new Command(this.types.join, 'Соединение линий', 'Соединить две линии', 'j', 'о', handleJoin, null),
            createTheSame: new Command(this.types.createTheSame, 'Создать похожий объект', 'Создание объекта с такими же свойствами как у выбранного объекта', 'y', 'н', handleCreateTheSame, null),
            hide: new Command(this.types.hide, 'Скрыть выбранные объекты', 'Скрыть выбранные объекты', 'h', 'р', handleHide, null),
            displayAll: new Command(this.types.displayAll, 'Показать все скрытые объекты', 'Показать все скрытые объекты', 'd', 'в', handleDisplayAll, null),
            moveRoutePart: new Command(this.types.moveRoutePart, 'Перемещение части маршрута', 'Переместить часть маршрута с сохранением соединений', 'u', 'г', null, null),
            // edit: new Command(this.types.edit, 'Редактирование фигур', 'Редактирование фигур путём перетаскивания ручек', null, null, null),
            dxf: new Command(this.types.dxf, 'Сохранить чертёж в DXF', 'Сохранить чертёж в DXF файл', 'ctrl+shift+u', 'ctrl+shift+г', generateDXFContent, null),
            pdf: new Command(this.types.pdf, 'Сохранить чертёж в PDF', 'Сохранить чертёж в PDF файл', 'ctrl+shift+o', 'ctrl+shift+щ', handleSavePdfButtonClick, null),
            save: new Command(this.types.save, 'Сохранить текущий чертёж', 'Сохранить текущий чертёж', 'ctrl+s', 'ctrl+ы', handleSaveShapesToDatabase, null),
            stamp: new Command(this.types.stamp, 'Редактировать основную надпись чертежа', 'Редактировать основную надпись чертежа', 'ctrl+shift+i', 'ctrl+shift+i', handleStampClick, null),
            networkHeating: new Command(this.types.networkHeating, 'Гидравлический расчёт', 'Расчёт сети системы отопления', 'ctrl+o', 'ctrl+щ', handleCalculateNetwork, null),
            callNetworkInfoWindow: new Command(this.types.callNetworkInfoWindow, 'Вызвать окно установки свойств', 'Вызвать окно установки свойств трубы (воздуховода) и установить фокус на его поле ввода', 'alt+1', 'alt+1', handleCallNetworkInfoWindow, null),
            focusFlowRateInput: new Command(this.types.focusFlowRateInput, 'Фокус на поле расхода', 'Показать окно свойств и установить фокус на поле ввода расхода', 'alt+2', 'alt+2', handleFocusFlowRateInput, null),
            escape: new Command(this.types.escape, 'Отмена', 'Отмена всех текущих действий', 'escape', 'escape', handleEscape, null),
            keyboard: new Command(this.types.keyboard, 'Сочетания клавиш', 'Переопределить сочетания клавиш для команд', 'ctrl+shift+k', 'ctrl+shift+л', handleKeyboard, null),
            makeBlock: new Command(this.types.makeBlock, 'Объединить в группу', 'Объединить выбранные элементы в группу', 'ctrl+b', 'ctrl+и', handleMakeBlock, null),

            assignConnectionPoints: new Command(this.types.assignConnectionPoints, 'Указать точку присоединения', 'Указать точку присоединения элемента воздуховода или трубопровода', 'f f', 'а а', handleAssignConnectionPoints, null),
            showBlockSearch: new Command(this.types.showBlockSearch, 'Показать окно поиска блоков', 'Показать окно поиска блоков',
                'ctrl+q', 'ctrl+й', handleShowBlockSearch, null
            ),
            hideBlockSearch: new Command(this.types.hideBlockSearch, 'Скрыть окно поиска блоков', 'Скрыть окно поиска блоков', 'esc', 'esc', handleHideBlockSearch, null),
            saveToBlockCollection: new Command(this.types.saveToBlockCollection, 'Добавить блок в коллекцию', 'Сохранить выбранный блок в коллекцию блоков', 'ctrl+b s', 'ctrl+и ы', handleSaveToBlockCollection, null),
        };
    }

    /**
     * Creates a sealed copy of the command map
     */
    public cmSealed(): Record<string, any> {
        const obj = JSON.stringify(this.cm);
        return JSON.parse(obj);
    }

    /**
     * Updates shortcuts from stored commands
     */
    public updateShortcuts(storedCommands: Array<Record<string, { shortcutEn: string | null; shortcutRu: string | null }>>): CommandMap {
        const commands = storedCommands[0];
        for (const key in commands) {
            const command = commands[key];
            
            if (this.cm[key]) {
                this.cm[key].shortcutEn = command.shortcutEn;
                this.cm[key].shortcutRu = command.shortcutRu;
                this.cm[key].updatedShortcut = command.shortcutEn;
            }
        }
        return this.cm;
    }
}

// Create and export the singleton instance
export const CommandList = new CommandListClass();
